import classnames from 'classnames';
import React from 'react';
import { NAV_TYPES } from '../../../LoggerFactory/BiAnalyticsLogger/events/consts';
import { ActiveLink } from '../../ActiveLink';
import { CustomLink } from '../../PageElements/CustomLink';
import { SectionTitleContent } from './SectionTitleContent';
import style from './TreeSectionTitle.scss';
import ChevronDownSmall from 'wix-ui-icons-common/ChevronDownSmall';

export const TreeSectionTitle = ({
  link,
  title,
  type,
  onClick,
  shouldShowPimple,
  isExpanded,
  onExpandButtonClick,
}) => (
  <ActiveLink>
    {({ isActive }) => (
      <div
        className={classnames({
          [style.linkWrapper]: true,
          [style.linkWrapperActive]: isActive(`/${link}`),
        })}
      >
        <CustomLink
          to={{
            pathname: `/${link}`,
            state: { navType: NAV_TYPES.MENU_CATEGORY },
          }}
          onClick={onClick}
          className={classnames({
            [style.sectionTitle]: true,
            [style.focusItem]: isActive(`/${link}`),
          })}
        >
          <SectionTitleContent
            shouldShowPimple={shouldShowPimple}
            type={type}
            title={title}
          />
        </CustomLink>
        <span
          className={style.chevronDownSmallWrapper}
          onClick={onExpandButtonClick}
          data-hook={`chevron-down-small-${link}`}
        >
          <ChevronDownSmall
            className={classnames({
              [style.nevigationMenuButton]: true,
              [style.expanded]: isExpanded,
            })}
          />
        </span>
      </div>
    )}
  </ActiveLink>
);
